import { render, staticRenderFns } from "./expenseClaim.vue?vue&type=template&id=1f98f8de&scoped=true"
import script from "./expenseClaim.vue?vue&type=script&lang=js"
export * from "./expenseClaim.vue?vue&type=script&lang=js"
import style0 from "./expenseClaim.vue?vue&type=style&index=0&id=1f98f8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98f8de",
  null
  
)

export default component.exports